import { Component, ChangeDetectionStrategy, Input } from "@angular/core";

@Component({
	selector: "app-staking-widget-sold-out",
	templateUrl: "./staking-widget-sold-out.component.html",
	styleUrls: ["./staking-widget-sold-out.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class StakingWidgetSoldOutComponent {
	@Input() public stakeableName: string = "";
}
